import Home from '@/views/home/home.view.vue';

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
];
